<template>

  <div v-bind:class="[`modal`, (modalActive) ? `is-active` : ``]">
    <div class="modal__background" @click="toggleModal()"></div>

    <div class="modal__container">

      <div class="modal__inner">

        <form action="POST" class="modal__form" @submit.stop.prevent="this.formSubmit(this.form)">

          <label for="room" class="modal__form-input">
            <div class="modal__form-input-label">room*</div>
            <select
              v-model="form.fields.room"
              id="room"
              name="room"
              class="modal__form-input-control"
            >
              <option
                v-for="option in this.rooms"
                :key="option"
                :value="option"
              >
                {{ option }}
              </option>
            </select>
          </label>

          <label for="title" class="modal__form-input">
            <div class="modal__form-input-label">title*</div>
            <input
              v-model="form.fields.title"
              type="text"
              name="title"
              id="title"
              ref="titleField"
              :class="['modal__form-input-control', {'is-invalid': form.errors.title }]"
            >
          </label>

          <label for="contact" class="modal__form-input">
            <div class="modal__form-input-label">contact*</div>
            <input
              v-model="form.fields.contact"
              type="text"
              name="contact"
              id="contact"
              placeholder="e.g. phone number"
              :class="['modal__form-input-control', {'is-invalid': form.errors.contact }]"
            >
          </label>

          <label for="comment" class="modal__form-input">
            <div class="modal__form-input-label">comment</div>
            <textarea
              v-model="form.fields.text"
              name="text"
              id="comment"
              class="modal__form-input-control"
            ></textarea>
          </label>

          <label for="date" class="modal__form-input">
            <div class="modal__form-input-label">date*</div>
            <input
              v-model="form.fields.date"
              type="date"
              name="date"
              id="date"
              :class="['modal__form-input-control', {'is-invalid': form.errors.date }]"
            >
          </label>

          <div class="modal__form-input">
            <label for="time_from" class="modal__form-input modal__form-input--w50 modal__form-input--w50-left">
              <div class="modal__form-input-label">time from*</div>
              <input
                v-model="form.fields.time_from"
                type="time"
                name="time_from"
                id="time_from"
                :class="['modal__form-input-control', {'is-invalid': form.errors.time_from }]"
              >
            </label>

            <label for="time_to" class="modal__form-input modal__form-input--w50 modal__form-input--w50-right">
              <div class="modal__form-input-label">time to*</div>
              <input
                v-model="form.fields.time_to"
                type="time"
                name="time_to"
                id="time_to"
                :class="['modal__form-input-control', {'is-invalid': form.errors.time_to }]"
              >
            </label>
          </div>

          <label for="noise" class="modal__form-input modal__form-input--checkbox">
            <input
              v-model="form.fields.noise"
              type="checkbox"
              name="noise"
              id="noise"
              true-value="1"
              false-value="0"
              class="modal__form-input-control"
            >
            <div class="modal__form-input-label">There will be noise</div>
          </label>

          <label for="silence" class="modal__form-input modal__form-input--checkbox">
            <input
              v-model="form.fields.silence"
              type="checkbox"
              name="silence"
              id="silence"
              true-value="1"
              false-value="0"
              class="modal__form-input-control"
            >
            <div class="modal__form-input-label">Silence is required</div>
          </label>

          <input
            v-model="form.fields.id"
            type="hidden"
            name="id"
          >

          <label class="modal__form-input modal__form-input--submit">
            <input
              type="submit"
              value="Save booking"
              class="modal__form-input-control"
              @click.stop.prevent="this.formValidate(this.form)"
            >
          </label>

          <button
            class="modal__remove-booking"
            v-if="bookingData.id"
            @click="removeBooking(bookingData.id)"
          >
            Remove booking
          </button>

        </form>

      </div>

      <button class="modal__close" @click="toggleModal()"></button>

    </div>
  </div>

</template>

<script>
import moment from 'moment'

export default {
  name: 'Modal',
  props: {
    rooms: Array,
    modalActive: Boolean,
    toggleModal: Function,
    bookingData: Object,
    removeBooking: Function,
    getBookings: Function,
    scheduleDate: Object
  },
  methods: {

    formValidate(data) {
      
      this.form.errors.title = (data.fields.title === ``) ? true : false
      this.form.errors.contact = (data.fields.contact === ``) ? true : false
      this.form.errors.date = (data.fields.date === ``) ? true : false

      const timeFromInt = parseInt(data.fields.time_from.replace(`:`, ``))
      const timeToInt = parseInt(data.fields.time_to.replace(`:`, ``))

      this.form.errors.time_from = (
        data.fields.time_from == `` ||
        timeFromInt < 800 ||
        timeFromInt > 2300 ||
        (timeToInt - timeFromInt < 100 && timeToInt !== 0)
      ) ? true : false

      this.form.errors.time_to = (
        (
          data.fields.time_to === `` ||
          timeToInt < timeFromInt ||
          timeToInt < 900 ||
          timeToInt - timeFromInt < 100
        ) && (
          timeToInt !== 0
        )
      ) ? true : false

      // submit if no errors found (contact is mandatory)
      if (!Object.values(this.form.errors).includes(true)) {
        this.formSubmit(data)
      }
    },

    formSubmit(data) {
      this.form.processing = 1

      fetch(`${process.env.VUE_APP_API_URL}?action=editBooking&id=${data.fields.id}`, {
        method: 'POST',
        body: JSON.stringify({
          id: data.fields.id,
          title: data.fields.title,
          text: data.fields.text,
          contact: data.fields.contact,
          room: data.fields.room,
          noise: parseInt(data.fields.noise),
          silence: parseInt(data.fields.silence),
          time_from: moment(`${data.fields.date} ${data.fields.time_from}`).utcOffset(2).unix(),
          time_to: moment(`${data.fields.date} ${data.fields.time_to}`).utcOffset(2).unix()
        })
      }).then(() => {
        this.toggleModal()
        this.getBookings(this.scheduleDate.month, this.scheduleDate.year)
        this.form.processing = 0
      }).catch(error => {
        console.error(error)
        this.form.processing = 0
      })
    }

  },
  data() {
    return {
      form: {
        processing: 0,
        errors: {
          title: false,
          contact: false,
          date: false,
          time_from: false,
          time_to: false
        },
        fields: {
          id: 0,
          title: ``,
          text: ``,
          contact: ``,
          room: this.rooms[0],
          date: moment().utcOffset(2).add(1, 'days').format('YYYY-MM-DD').toString(),
          time_from: `12:00`,
          time_to: `16:00`,
          noise: 0,
          silence: 0
        }
      }
    }
  },
  watch: {
    bookingData: {
      handler: function (data) {
        if (data.id) {
          fetch(`${process.env.VUE_APP_API_URL}?action=getBooking&id=${data.id}`)
              .then(response => response.json())
              .then(data => {
                if (Object.keys(data).length !== 0) {
                  this.form.fields.id = data.id
                  this.form.fields.room = data.room
                  this.form.fields.title = data.title
                  this.form.fields.text = data.text
                  this.form.fields.contact = data.contact || ``
                  this.form.fields.noise = data.noise
                  this.form.fields.silence = data.silence
                  this.form.fields.date = moment.unix(data.time_from).format(`YYYY-MM-DD`)
                  this.form.fields.time_from = moment.unix(data.time_from).format(`HH:mm`)
                  this.form.fields.time_to = moment.unix(data.time_to).format(`HH:mm`)
                }
              })
        } else {
          this.form.fields.room = data.room
          this.form.fields.date = moment(data.date, `YYYY-M-DD`).format(`YYYY-MM-DD`)
          this.form.fields.time_from = data.time_from
          this.form.fields.time_to = moment(data.time_from, `HH:mm`).add(1, 'hours').format(`HH:mm`)
        }

      },
      deep: true
    },
    modalActive: function (value) {
      if (!value) {
        this.form.fields.id = 0
        this.form.fields.title = ``
        this.form.fields.text = ``
        this.form.fields.contact = ``
        this.form.fields.room = this.rooms[0]
        this.form.fields.date = moment().add(1, 'days').format('YYYY-MM-DD').toString()
        this.form.fields.time_from = `12:00`
        this.form.fields.time_to = `16:00`
        this.form.fields.noise = 0
        this.form.fields.silence = 0
      } else {
        this.$refs.titleField.focus()
      }
    }
  }
}
</script>

<style>
.modal {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  opacity: 0;
  transition: .2s;
  position: fixed;
  pointer-events: none;
}

.modal__background {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .7);
  position: absolute;
}

.modal.is-active {
  opacity: 1;
  pointer-events: all;
}

.modal__container {
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 640px;
  border-radius: 10px;
  max-height: calc(100vh - 60px);
  background-color: #fff;
  color: #111;
  position: relative;
  display: flex;
  flex-direction: column;
}

.modal__inner {
  width: 100%;
  height: 100%;
  padding: 40px 40px 10px 40px;
  overflow: auto;
  position: relative;
}

@media (max-width: 640px) {
  .modal__inner {
    padding: 25px;
  }
}

.modal__form-input {
  width: 100%;
  display: flex;
  margin-bottom: 30px;
  position: relative;
}

.modal__form-input--w50 {
  width: 50%;
  margin: 0;
}

.modal__form-input--w50-left {
  margin-right: 10px;
}

.modal__form-input--w50-right {
  margin-left: 10px;
}

.modal__form-input--checkbox {
  display: flex;
  align-items: center;
}

.modal__form-input-label {
  top: 0;
  left: 15px;
  padding: 0 10px;
  line-height: 1;
  font-weight: 700;
  font-size: 14px;
  transform: translateY(-50%);
  color: #666;
  background-color: #fff;
  position: absolute;
}

.modal__form-input--checkbox .modal__form-input-label {
  margin: 0 10px 0 0;
  padding: 0;
  color: #111;
  left: auto;
  transform: none;
  position: relative;
}

.modal__form-input-control {
  width: 100%;
  height: 44px;
  border: 2px solid #666;
  border-radius: 10px;
  outline: 0;
  font-size: 16px;
  padding: 0 10px;
  font-family: Tahoma, sans-serif;
}

.modal__form-input-control.is-invalid {
  border-color: #ec4646;
}

textarea.modal__form-input-control {
  padding: 10px;
  height: 80px;
  resize: none;
}

input[type="checkbox"].modal__form-input-control {
  width: 24px;
  height: 24px;
  margin: 0 12px 0 0;
}

input[type="submit"].modal__form-input-control {
  width: 100%;
  margin: 0 auto;
  display: block;
  color: #fff;
  background-color: #111;
  letter-spacing: 1px;
  font-weight: 700;
  border: 0;
  cursor: pointer;
  text-transform: uppercase;
}

@media (min-width: 1025px) {

  input[type="submit"].modal__form-input-control {
    max-width: 300px;
    opacity: .7;
  }

  input[type="submit"].modal__form-input-control:hover {
    opacity: 1;
  }

}

.modal__remove-booking {
  border: 0;
  outline: 0;
  font-weight: 700;
  margin: 0 auto 30px auto;
  font-size: 14px;
  background: none;
  cursor: pointer;
  color: #ec4646;
  display: block;
}

.modal__close {
  border: 0;
  outline: 0;
  right: -10px;
  top: -10px;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  box-shadow: 0 0 5px rgba(0, 0, 0, .5);
  background-color: #fff;
  position: absolute;
  cursor: pointer;
}

@media (min-width: 1025px) {

  .modal__close:hover {
    background-color: #ec4646;
  }

}

.modal__close:before,
.modal__close:after {
  content: '';
  left: 50%;
  top: 50%;
  width: 50%;
  height: 3px;
  position: absolute;
  background-color: #111;
  transform: translate(-50%, -50%) rotate(45deg);
}

.modal__close:after {
  transform: translate(-50%, -50%) rotate(-45deg);
}

@media (min-width: 1025px) {

  .modal__close:hover:before,
  .modal__close:hover:after {
    background-color: #fff;
  }

}

</style>
